<div
  class="rounded-2xl border !border-slate-200/70 bg-white p-6 md:p-8 shadow-[0_24px_60px_-24px_rgba(15,23,42,.25)]"
>
  <div class="flex items-start justify-between gap-3">
    <div>
      <div
        class="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.12em] text-[var(--primary-color)]"
      >
        <span class="w-1.5 h-1.5 rounded-full bg-[var(--primary-color)]"></span>
        Dit forløb
      </div>
      @if (plan?.track) {
        <p class="text-[12px] text-slate-600 mt-2">
          Du er nu på
          <span class="font-semibold">{{ plan?.track }}</span> forløb
        </p>
      } @else if (score) {
        <p class="text-[15px] text-slate-600 mt-2">
          Du er nu på
          <span class="font-semibold">{{ score.trackLabel }}</span> forløb
        </p>
      }
    </div>
    <button
      type="button"
      (click)="onResetClick()"
      class="shrink-0 text-[13px] font-medium !text-slate-500 hover:!text-[var(--primary-color)] underline-offset-2 hover:underline transition-colors"
    >
      Nulstil profil
    </button>
  </div>

  @if (loading) {
    <div
      class="flex flex-col items-center justify-center gap-3 py-12 text-slate-500"
    >
      <span
        class="w-8 h-8 rounded-full border-2 border-slate-200 border-t-[var(--primary-color)] animate-spin"
      ></span>
      <span class="text-[13px]">Genererer din plan…</span>
    </div>
  } @else if (plan) {
    @if (plan.summary) {
      <p class="text-[14px] leading-relaxed text-slate-600 mt-4">
        {{ plan.summary }}
      </p>
    }

    <div class="mt-5 grid grid-cols-1 md:grid-cols-3 gap-3">
      @if (plan.sprintId) {
        <a
          [routerLink]="sprintLink()"
          [queryParams]="{ type: sprintTypeParam }"
          [class]="tileClass"
        >
          <span [class]="tileIconClass">
            <igntr-icon name="play" [size]="20"></igntr-icon>
          </span>
          <span class="min-w-0 flex-1">
            <span [class]="tileEyebrowClass">{{
              plan.sprintKind === "Onboarding" ? "ONBOARDING" : "SPRINT"
            }}</span>
            <span [class]="tileTitleClass">{{
              plan.sprintName || "Dit sprint"
            }}</span>
          </span>
          <igntr-icon
            name="chevronR"
            [size]="18"
            [class]="tileChevronClass"
          ></igntr-icon>
        </a>
      }

      @for (area of plan.focusAreas; track area.name) {
        <a [routerLink]="focusAreaLink(area)" [class]="tileClass">
          <span [class]="tileIconClass">
            <igntr-icon name="target" [size]="20"></igntr-icon>
          </span>
          <span class="min-w-0 flex-1">
            <span [class]="tileEyebrowClass">PERSONLIG PLAN · MÅL</span>
            <span [class]="tileTitleClass">{{ area.name }}</span>
          </span>
          <igntr-icon
            name="chevronR"
            [size]="18"
            [class]="tileChevronClass"
          ></igntr-icon>
        </a>
      }
    </div>
  } @else if (score) {
    <div class="mt-5 grid grid-cols-1 md:grid-cols-2 gap-3">
      @for (name of score.focusAreas; track name) {
        <div [class]="tileClass">
          <span [class]="tileIconClass">
            <igntr-icon name="target" [size]="20"></igntr-icon>
          </span>
          <span class="min-w-0 flex-1">
            <span [class]="tileEyebrowClass">PERSONLIG PLAN · MÅL</span>
            <span [class]="tileTitleClass">{{ name }}</span>
          </span>
        </div>
      }
    </div>
  }
</div>

@if (confirmOpen) {
  <div
    class="fixed inset-0 z-[1000] flex items-center justify-center p-4"
    style="background-color: rgba(15, 23, 42, 0.45); backdrop-filter: blur(4px)"
    role="dialog"
    aria-modal="true"
    aria-label="Nulstil profil"
    (click)="onConfirmCancel()"
  >
    <div
      class="igntr-theme w-full max-w-[420px] rounded-2xl border-0 bg-white shadow-[0_24px_60px_-24px_rgba(15,23,42,.45)]"
      (click)="$event.stopPropagation()"
    >
      <div
        class="flex items-center justify-between gap-3"
        style="padding: 16px 18px 12px"
      >
        <h6 class="m-0 text-[16px] font-semibold !text-slate-900">
          Nulstil profil
        </h6>
        <button
          type="button"
          aria-label="Luk"
          (click)="onConfirmCancel()"
          class="shrink-0 rounded-md !text-slate-400 hover:!text-slate-700 hover:bg-slate-100 inline-flex transition-colors"
          style="padding: 6px"
        >
          <igntr-icon name="close" [size]="16"></igntr-icon>
        </button>
      </div>

      <div style="padding: 0 18px 16px">
        <p class="m-0 text-[14px] !text-slate-600">
          Er du sikker? Dette nulstiller din profil og sletter din plan, så du
          skal udfylde spørgeskemaet igen.
        </p>
      </div>

      <div
        class="flex items-center justify-end gap-2 border-t !border-slate-100 bg-slate-50/50 rounded-b-2xl"
        style="padding: 12px 18px"
      >
        <button
          type="button"
          (click)="onConfirmCancel()"
          class="text-[14px] h-9 rounded-lg font-medium inline-flex items-center justify-center transition-colors bg-white border !border-slate-200 !text-slate-700 hover:!bg-slate-50"
          style="padding: 0 14px"
        >
          Annuller
        </button>
        <button
          type="button"
          (click)="onConfirmReset()"
          class="text-[14px] h-9 rounded-lg font-medium inline-flex items-center justify-center transition-colors bg-[var(--primary-color)] text-white hover:opacity-90"
          style="padding: 0 14px"
        >
          Nulstil profil
        </button>
      </div>
    </div>
  </div>
}
